import React from 'react';
import rdPlatformConfig from 'artifact/app-config.json';
import Phone1 from 'asset/image/phone-1.svg';
import Phone2 from 'asset/image/phone-2.svg';
import Home from 'asset/icon/outlined/home.svg';
import RightArrow from 'asset/icon/outlined/right-arrow.svg';
import Help from 'asset/icon/outlined/help.svg';
import About from 'asset/icon/outlined/about.svg';
import Car from 'asset/icon/outlined/car.svg';
import Motorbike from 'asset/icon/filled/motorbike.svg';
import Community from 'asset/icon/filled/community.svg';
import Phone from 'asset/icon/outlined/phone.svg';
import SmallCar from 'artifact/small-car';
import Search from 'asset/icon/outlined/search.svg';
import News1 from 'asset/image/news-1.svg';
import News2 from 'asset/image/news-2.svg';
import News4 from 'asset/image/news-4.svg';
import News5 from 'asset/image/news-5.svg';
import SmallPhone from 'artifact/small-phone';
import SmallBike from 'artifact/small-bike';
import Quality from 'artifact/quality';
import Battery from 'artifact/battery';
import Speed from 'artifact/speed';
import Eye from 'artifact/eye';
import AppGrid from 'artifact/app-grid';
import UserPhoneMotorola from 'asset/image/user-phone-motorola.svg';
import UserPhoneRedmi from 'asset/image/user-phone-redmi.svg';
import UserPhonePoco from 'asset/image/user-phone-poco.svg';

export const DESIGN_CONFIG = rdPlatformConfig.design;

export const SETTING_CONFIG = rdPlatformConfig.setting;

export const STRING_CONFIG = rdPlatformConfig.string;

export const PATHS = {
  PRIVACY_POLICY: '/privacy-policy',
  TERMS: '/terms-of-service',
  HELP: '/help',
  PROFILE: '/profile',
  USER: '/user-profile',
};

export const RECENTLY_VIEWED = [
  {
    id: 1,
    Image: Phone1,
    'Brand Name': 'MOTOROLA G60 (Moonless, 128 GB) (6 GB RAM)',
    rating: 4.2,
  },
  {
    id: 2,
    Image: Phone2,
    'Brand Name': 'Redmi 10 Prime (Phantom Black 4GB RAM 64GB ',
    rating: 4.2,
  },
  {
    id: 3,
    Image: Phone1,
    'Brand Name': 'MOTOROLA G60 (Moonless, 128 GB) (6 GB RAM)',
    rating: 4.2,
  },
  {
    id: 4,
    Image: Phone1,
    'Brand Name': 'MOTOROLA G60 (Moonless, 128 GB) (6 GB RAM)',
    rating: 4.2,
  },
  {
    id: 5,
    Image: Phone2,
    'Brand Name': 'Redmi 10 Prime (Phantom Black 4GB RAM 64GB ',
    rating: 4.2,
  },
  {
    id: 6,
    Image: Phone1,
    'Brand Name': 'MOTOROLA G60 (Moonless, 128 GB) (6 GB RAM)',
    rating: 4.2,
  },
];

export const DISPLAY_FEATURES = [
  { id: 1, name: 'Resolution', checked: false },
  { id: 2, name: 'Features', checked: false },
];

export const CONNECTIVITY_FEATURES = [
  { id: 1, name: 'USB', checked: false },
  { id: 2, name: 'WIFI', checked: false },
  { id: 3, name: 'NFC', checked: false },
  { id: 4, name: 'Bluetooth', checked: false },
];

export const CAMERA_FEATURES = [
  { id: 1, name: 'Primary Camera', checked: false },
  { id: 2, name: 'Front Camera', checked: false },
  { id: 3, name: 'Zoom', checked: false },
  { id: 4, name: 'Flash', checked: false },
  { id: 5, name: 'Video Recording', checked: false },
];

export const GENERAL_FEATURES = [
  { id: 1, name: 'SIM Type', checked: false },
  { id: 2, name: 'SIM Size', checked: false },
  { id: 3, name: 'Network Type', checked: false },
  { id: 4, name: 'Removable Battery', checked: false },
  { id: 5, name: 'Sensors', checked: false },
];

export const PERFORMANCE = [
  { id: 1, name: 'Processor', checked: false },
  { id: 2, name: 'Graphics', checked: false },
  { id: 3, name: 'Operating System', checked: false },
];

export const REVIEWS = [
  { id: 1, name: 'Top Reviews', checked: false },
  { id: 2, name: '1 Star Reviews', checked: false },
  { id: 3, name: '2 Star Reviews', checked: false },
];

export const STORAGE = [
  { id: 1, name: 'Internal Memory', checked: false },
  { id: 2, name: 'Extended Memory', checked: false },
];

export const CATEGORY_TEXT = [
  '1) Select the type of product you are planning to buy',
  '2) What’s your budget?',
  '3) Select 3 attributes you prefer the most',
];

export const BUYING_TYPES = [
  {
    id: 1,
    name: 'Phones',
    border: 'none',
    background: DESIGN_CONFIG.color.neutral.neutral200,
    icon: <SmallPhone />,
    text: DESIGN_CONFIG.color.text.text100,
    fill: '',
  },
  {
    id: 2,
    name: 'Cars',
    border: 'none',
    background: DESIGN_CONFIG.color.neutral.neutral200,
    icon: SmallCar,
    text: DESIGN_CONFIG.color.text.text100,
    fill: '',
  },
  {
    id: 3,
    name: 'Motorbike',
    border: 'none',
    background: DESIGN_CONFIG.color.neutral.neutral200,
    icon: SmallBike,
    text: DESIGN_CONFIG.color.text.text100,
    fill: '',
  },
];

export const ATTRIBUTE_TYPES = [
  {
    id: 1,
    name: 'Performance',
    border: DESIGN_CONFIG.color.primary.primaryMain,
    background: DESIGN_CONFIG.color.neutral.neutral200,
    icon: Speed,
    text: DESIGN_CONFIG.color.text.text100,
    fill: '',
  },
  {
    id: 2,
    name: 'Battery Life',
    border: 'none',
    background: DESIGN_CONFIG.color.neutral.neutral200,
    icon: Battery,
    text: DESIGN_CONFIG.color.text.text100,
    fill: '',
  },
  {
    id: 3,
    name: 'Appearance',
    border: 'none',
    background: DESIGN_CONFIG.color.neutral.neutral200,
    icon: Eye,
    text: DESIGN_CONFIG.color.text.text100,
    fill: '',
  },
  {
    id: 4,
    name: 'Hardware',
    border: 'none',
    background: DESIGN_CONFIG.color.neutral.neutral200,
    icon: SmallPhone,
    text: DESIGN_CONFIG.color.text.text100,
    fill: '',
  },
  {
    id: 5,
    name: 'OS & Software',
    border: 'none',
    background: DESIGN_CONFIG.color.neutral.neutral200,
    icon: AppGrid,
    text: DESIGN_CONFIG.color.text.text100,
    fill: '',
  },
  {
    id: 6,
    name: 'Build Quality',
    border: 'none',
    background: DESIGN_CONFIG.color.neutral.neutral200,
    icon: Quality,
    text: DESIGN_CONFIG.color.text.text100,
    fill: '',
  },
];

export const PRODUCT_REVIEW_DATA = [
  {
    id: 1,
    name: 'MOTOROLA G60 (Moonless, 128 GB) (6 GB RAM)',
    rating: '4.2',
    desc: 'The best budget phone. Camera clarity is good. Value for money. Right size phone with light weight. Over all good phone with budget price.',
    date: '21 Sep, 2020',
    image: UserPhoneMotorola,
  },
  {
    id: 2,
    name: 'REDMI Note 10S (Shadow Black, 64 GB)  (6 GB RAM)',
    rating: '4.2',
    desc: 'The best budget phone. Camera clarity is good. Value for money. Right size phone with light weight. Over all good phone with budget price.',
    date: '24 May, 2020',
    image: UserPhoneRedmi,
  },
  {
    id: 3,
    name: 'POCO C31 (Royal Blue, 64 GB) (4 GB RAM)',
    rating: '4.2',
    desc: 'The best budget phone. Camera clarity is good. Value for money. Right size phone with light weight. Over all good phone with budget price.',
    date: '24 May, 2020',
    image: UserPhonePoco,
  },
  {
    id: 4,
    name: 'POCO C31 (Royal Blue, 64 GB) (4 GB RAM)',
    rating: '4.2',
    desc: 'The best budget phone. Camera clarity is good. Value for money. Right size phone with light weight. Over all good phone with budget price.',
    date: '24 May, 2020',
    image: UserPhonePoco,
  },
];

export const PRODUCT_SHARE_DATA = [
  {
    id: 1,
    name: 'MOTOROLA G60 (Moonless, 128 GB) (6 GB RAM)',
    rating: '4.2',
    desc: 'The best budget phone. Camera clarity is good. Value for money. Right size phone with light weight. Over all good phone with budget price.',
    date: '21 Sep, 2020',
    image: UserPhoneMotorola,
  },
];

export const PRODUCTS_LIST = [
  {
    id: 1,
    name: 'Home',
    image: Home,
    marginLeft: '10px',
    selected: true,
  },
  {
    id: 2,
    name: 'Phones',
    image: Phone,
    marginLeft: '10px',
    right: RightArrow,
    margin: '10px',
  },
  {
    id: 3,
    name: 'Cars',
    image: Car,
    marginLeft: '10px',
    right: RightArrow,
  },
  {
    id: 4,
    name: 'Motorbikes',
    image: Motorbike,
    marginLeft: '10px',
    right: RightArrow,
  },
  {
    id: 5,
    name: 'Buying Guide',
    image: Search,
    marginLeft: '10px',
  },
  {
    id: 6,
    name: 'Community',
    image: Community,
    marginLeft: '10px',
  },
  {
    id: 7,
    name: 'About ReviewDale',
    image: About,
    marginLeft: '10px',
  },
  {
    id: 8,
    name: 'Help & support',
    image: Help,
    marginLeft: '10px',
    right: RightArrow,
  },
];

export const NEWS = [
  {
    id: 1,
    image: News1,
    text: 'Amidst rumors, Tesla finally sets up a new factory in Bangalore',
  },
  {
    id: 2,
    image: News2,
    text: 'Apple to launch a compact iPhone this November, but won’t be availab..',
  },

  {
    id: 4,
    image: News4,
    text: 'iWatch sales to surpass Samsung Gear pretty soon in Europe',
  },
  {
    id: 5,
    image: News5,
    text: 'BMW G310R to receive a facelift with a ton of new safety features',
  },
];

export const ERROR_TYPES = {
  EMAIL_INVALID: 'Please enter a valid email address',
  REVIEWDALE_EMAIL: 'Please enter your email',
  PASSWORD_INVALID: 'entered password is not correct',
  LEFT_BLANK: 'Cannot be left blank',
  PASSWORD_MISMATCH: 'Passwords are not matching',
  LEAST_CHARACTER_PASSWORD: 'password should have atleast 6 characters',
  WEAK_PASSWORD:
    'your password is weak ( use atleast one uppercase, one lowercase and one alphanumeric characters)',
  STRONG_PASSWORD: 'great!, now you have a strong password',
};

export const LIST = [
  {
    id: 1,
    text: 'Definitions',
    desc: `
  
     
  The parties referred to in these Terms of Service shall be defined as follows:
        <br/>
  a) Owner, Us, We: The Owner, as the creator, operator, and publisher of the Website makes the Website, and certain Services on it, available to users. Reviewdale, Owner, Us, We, Our, Ours and other first-person pronouns will refer to the Owner, as well as all employees and affiliates of the Owner.
        <br/>
  b) You, the User, the Client: You, as the user of the Website, will be referred to throughout these Terms of Service with second-person pronouns such as You, Your, Yours, or as User or Client. For the purpose of these Terms of Service, the term "User" or "you" shall mean any natural or legal person who person is accessing the Website. The term '"Your are " shall be construed accordingly.
        <br/>
  c) Parties: Collectively, the parties to these Terms of Service (the Owner and You) will be referred to as Parties.
      </p>
   `,
  },
  {
    id: 2,
    text: 'Assent & Acceptance',
    desc: `By using the Website, You warrant that You have read and reviewed these Terms of Service and that You agree to be bound by them. If You disagree to be bound by these Terms of Service, please leave the Website immediately. The Owner only agrees to provide use of this Website and Services to You if You assent to these Terms of Service. Further, based on the Services obtained by a User, additional terms of service in respect of the specific Services may apply, which shall be deemed an agreement between the Users and the Owner.
  `,
  },
  {
    id: 3,
    text: 'About The Site',
    desc: `
   <span style="color:#0598FA">The Website is an online product reviewing platform which helps users add their own reviews for products and read reviews of products from other users. We reserve the right to refuse service or refuse to share information on the Website at our sole discretion to anyone for any reason at any time.</span>
         <br/>
   The Website does not screen or censor the users who register on and access the Website. You assume all risks associated with dealing with other users with whom you come in contact through the Website. You agree to use the Website only for lawful purposes without infringing the rights of or restricting the use of this Website by any third party.
       `,
  },
  {
    id: 4,
    text: 'License To Use Website',
    desc: `The Owner may provide You with certain information as a result of Your use of the Website or Services. Such information may include but is not limited to, documentation, data, or information developed by the Owner, and other materials which may assist in Your use of the Website or Services ("Owner Materials"). Subject to these Terms of Service, the Owner grants You a non-exclusive, limited, non-transferable and revocable license to use the Owner Materials solely in connection with Your use of the Website and Services. The Owner Materials may not be used for any other purpose and this license terminates upon Your cessation of use of the Website or Services or at the termination of these Terms of Service.
   <br/>
You agree not to collect contact information of other Users from the Website or download or copy any information by means of unsolicited access so as to communicate directly with them or for any reason whatsoever.
   <br/>
Any unauthorized use by you shall terminate the permission or license granted to you by the Website and You agree that you shall not bypass any measures used by the Owner to prevent or restrict access to the Website.
`,
  },
  {
    id: 5,
    text: 'Intellectual Property',
    desc: `You agree that the Website and all Services provided by the Owner are the property of the Owner, including all copyrights, trademarks, trade secrets, patents, and other intellectual property ("Owner IP"). You agree that the Owner owns all rights, title, and interest in and to the Owner IP and that You will not use the Owner IP for any unlawful or infringing purpose. You agree not to reproduce or distribute the Owner IP in any way, including electronically or via registration of any new trademarks, trade names, service marks or Uniform Resource Locators (URLs), without express written permission from the Owner.
  <br/>
a) In order to make the Website and Services available to You, You hereby grant the Owner a royalty-free, non-exclusive, worldwide license to copy, display, use, broadcast, transmit and make derivative works of any content You publish, upload or otherwise make available to the Website ("Your Content"). The Owner claims no further proprietary rights in Your Content.
  <br/>
b) If You feel that any of Your intellectual property rights have been infringed or otherwise violated by the posting of information or media by another of Our users, please contact Us and let Us know.
`,
  },
  {
    id: 6,
    text: 'User Obligations',
    desc: `
 
As a user of the Website or Services, You may be asked to register with Us. When You do so, You will choose a user identifier, which may be Your email address or another term, as well as a password. You may also provide personal information, including, but not limited to, Your name. You are responsible for ensuring the accuracy of this information. This identifying information will enable You to use the Website and Services. You must not share such identifying information with any third party and if You discover that Your identifying information has been compromised, You agree to notify Us immediately in writing. An email notification will suffice. You are responsible for maintaining the safety and security of Your identifying information as well as keeping Us apprised of any changes to Your identifying information. The billing information You provide us, including credit card, billing address and other payment information, is subject to the same confidentiality and accuracy requirements as the rest of Your identifying information. Providing false or inaccurate information, or using the Website or Services to further fraud or unlawful activity is grounds for immediate termination of these Terms of Service. The Owner reserves the right to refuse service, terminate accounts, or remove or edit content at its sole discretion.
  `,
  },
  {
    id: 7,
    text: 'Payment & Fees',
    desc: `Should You register for any of the paid Services on this website or purchase any product or service on this website, You agree to pay Us the specific monetary amounts required for that product or those Services. These monetary amounts ("Fees") will be described to You during Your account registration and/or confirmation process. The final amount required for payment will be shown to You immediately prior to purchase.
  <br/>
We reserve the right to refuse service or refuse to sell the products on the Website at our sole discretion to anyone for any reason at any time.
`,
  },
  {
    id: 8,
    text: 'Acceptable Use',
    desc: `
  You agree not to use the Website or Services for any unlawful purpose or any purpose prohibited under this clause. You agree not to use the Website or Services in any way that could damage the Website, Services or general business of the Owner.
        <br/>
  a) You further agree not to use the Website or Services:
        <br/>
  I) To harass, abuse, or threaten others or otherwise violate any person's legal rights;
        <br/>
  II) To violate any intellectual property rights of the Owner or any third party;
        <br/>
  III) To upload or otherwise disseminate any computer viruses or other software that may damage the property of another;
        <br/>
  IV) To perpetrate any fraud;
        <br/>
  V) To engage in or create any unlawful gambling, sweepstakes, or pyramid scheme;
        <br/>
  VI) To publish or distribute any obscene or defamatory material;
        <br/>
  VII) To publish or distribute any material that incites violence, hate or discrimination towards any group;
        <br/>
  VIII) To unlawfully gather information about others.
        <br/>
  You are prohibited from using the site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to infringe on any third party's intellectual property or proprietary rights, or rights of publicity or privacy, whether knowingly or unknowingly; (d) to violate any local, federal or international law, statute, ordinance or regulation; ((e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information or any content which is defamatory, libelous, threatening, unlawful, harassing, indecent, abusive, obscene, or lewd and lascivious or pornographic, or exploits minors in any way or assists in human trafficking or content that would violate rights of publicity and/or privacy or that would violate any law; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to damage, disable, overburden, or impair the Website or any other party's use of the Website; (j) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet; (l) to personally threaten or has the effect of personally threatening other Users. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses. The Company has the full authority to review all content posted by Users on the Website. You acknowledge that the Website is not responsible or liable and does not control the content of any information that may be posted to the Website by You or other Users of the Website and you are solely responsible for the same. You agree that You shall not upload, post, or transmit any content that you do not have a right to make available (such as the intellectual property of another party).
        <br/>
  You agree to comply with all applicable laws, statutes and regulations concerning your use of the Website and further agree that you will not transmit any information, data, text, files, links, software, chats, communication or other materials that are abusive, invasive of another's privacy, harassing, defamatory, vulgar, obscene, unlawful, false, misleading, harmful, threatening, hateful or racially or otherwise objectionable, including without limitation material of any kind or nature that encourages conduct that could constitute a criminal offence, give rise to civil liability or otherwise violate any applicable local, state, provincial, national, or international law or regulation, or encourage the use of controlled substances.
        <br/>
  We may, but have no obligation to, monitor, edit or remove content that we determine in our sole discretion are unlawful, offensive, threatening, libellous, defamatory, pornographic, obscene or otherwise objectionable or violates any party's intellectual property or these Terms of Service.
        <br/>
  You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).
    `,
  },
  {
    id: 9,
    text: 'Communication',
    desc: `
  You understand that each time uses the Website in any manner, you agree to these Terms. By agreeing to these Terms, you acknowledge that you are interested in availing and purchasing the Services that you have selected and consent to receive communications via phone or electronic records from the Website including e-mail messages telling you about products and services offered by the Website (or its affiliates and partners) and understanding your requirements. Communication can also be by posting any notices on the Website. You agree that the communications sent to You by the Website shall not be construed as spam or bulk under any law prevailing in any country where such communication is received.`,
  },
  {
    id: 10,
    text: 'Affiliate Market Advertising',
    desc: `
  
The Owner, through the Website and Services, may engage in affiliate marketing whereby the Owner receives a commission on or percentage of the sale of goods or services on or through the Website. The Owner may also accept advertising and sponsorships from commercial businesses or receive other forms of advertising compensation.
  `,
  },
  {
    id: 11,
    text: 'Privacy Information',
    desc: `
  Through Your Use of the Website and Services, You may provide Us with certain information. By using the Website or the Services, You authorize the Owner to use Your information in India and any other country where We may operate.
  
  a) Information We May Collect or Receive: When You register for an account, You provide Us with a valid email address and may provide Us with additional information, such as Your name or billing information. Depending on how You use Our Website or Services, We may also receive information from external applications You use to access Our Website, or We may receive information through various web technologies, such as cookies, log files, clear gifs, web beacons or others.
  
  b) How We Use Information: We use the information gathered from You to ensure Your continued good experience on Our website, including through email communication. We may also track certain of the passive information received to improve Our marketing and analytics, and for this, We may work with third-party providers.
  
  c) How You Can Protect Your Information: If You would like to disable Our access to any passive information We receive from the use of various technologies, You may choose to disable cookies in Your web browser. Please be aware that the Owner will still receive information about You that You have provided, such as Your email address.`,
  },
  {
    id: 12,
    text: 'Sale Of Goods / Services',
    desc: `
  
  The Owner may sell goods or services or allow third parties to sell goods or services on the Website. The Owner undertakes to be as accurate as possible with all information regarding the goods and services, including product descriptions and images. However, the Owner does not guarantee the accuracy or reliability of any product information and You acknowledge and agree that You purchase such products at Your own risk.
  `,
  },
  {
    id: 13,
    text: 'Reverse Engineering & Security',
    desc: `You agree not to undertake any of the following actions:
   <br/>
a) Reverse engineer, or attempt to reverse engineer or disassemble any code or software from or on the Website or Services;
   <br/>
b) Violate the security of the Website or Services through any unauthorized access, circumvention of encryption or other security tools, data mining or interference with any host, user or network.
`,
  },
  {
    id: 14,
    text: 'Data Loss',
    desc: `
  The Owner does not accept responsibility for the security of Your account or content. You agree that Your use of the Website or Services is at Your own risk. `,
  },
  {
    id: 15,
    text: 'Indemnification',
    desc: `
  You agree to defend and indemnify the Owner and any of its affiliates (if applicable) and hold Us harmless against any and all legal claims and demands, including reasonable attorney's fees, which may arise from or relate to Your use or misuse of the Website or Services, Your breach of these Terms of Service, or Your conduct or actions. You agree that the Owner shall be able to select its own legal counsel and may participate in its own defence if the Owner wishes.`,
  },
  {
    id: 16,
    text: 'Spam Policy',
    desc: `
  
You are strictly prohibited from using the Website or any of the Owner's Services for illegal spam activities, including gathering email addresses and personal information from others or sending any mass commercial emails.
  `,
  },
  {
    id: 17,
    text: 'Third - Party Links & Content',
    desc: `
 
The Owner may occasionally post links to third-party websites or other services. You agree that the Owner is not responsible or liable for any loss or damage caused as a result of Your use of any third-party services linked to Our Website.
  `,
  },
  {
    id: 18,
    text: 'Modification & Variation',
    desc: `The Owner may, from time to time and at any time without notice to You, modify these Terms of Service. You agree that the Owner has the right to modify these Terms of Service or revise anything contained herein. You further agree that all modifications to these Terms of Service are in full force and effect immediately upon posting on the Website and that modifications or variations will replace any prior version of these Terms of Service unless prior versions are specifically referred to or incorporated into the latest modification or variation of these Terms of Service.
  <br/>
a) To the extent any part or sub-part of these Terms of Service is held ineffective or invalid by any court of law, You agree that the prior, effective version of these Terms of Service shall be considered enforceable and valid to the fullest extent.
  <br/>
b) You agree to routinely monitor these Terms of Service and refer to the Effective Date posted at the top of these Terms of Service to note modifications or variations. You further agree to clear Your cache when doing so to avoid accessing a prior version of these Terms of Service. You agree that Your continued use of the Website after any modifications to these Terms of Service is a manifestation of Your continued assent to these Terms of Service.
  <br/>
c) In the event that You fail to monitor any modifications to or variations of these Terms of Service, You agree that such failure shall be considered an affirmative waiver of Your right to review the modified Agreement.
`,
  },
  {
    id: 19,
    text: 'Entire Agreement',
    desc: `
  
This Agreement constitutes the entire understanding between the Parties with respect to any and all use of this Website. This Agreement supersedes and replaces all prior or contemporaneous agreements or understandings, written or oral, regarding the use of this Website.
  `,
  },
  {
    id: 20,
    text: 'Service Interruptions',
    desc: `
  The Owner may need to interrupt Your access to the Website to perform maintenance or emergency services on a scheduled or unscheduled basis. You agree that Your access to the Website may be affected by unanticipated or unscheduled downtime, for any reason, but that the Owner shall have no liability for any damage or loss caused as a result of such downtime.`,
  },
  {
    id: 21,
    text: 'Term , Termination & Suspension',
    desc: `
  
The Owner may terminate these Terms of Service with You at any time for any reason, with or without cause. The Owner specifically reserves the right to terminate these Terms of Service if You violate any of the terms outlined herein, including, but not limited to, violating the intellectual property rights of the Owner or a third party, failing to comply with applicable laws or other legal obligations, and/or publishing or distributing illegal material. If You have registered for an account with Us, You may also terminate these Terms of Service at any time by contacting Us and requesting termination. Please keep in mind that any outstanding fees will still be due even after the termination of Your account. At the termination of these Terms of Service, any provisions that would be expected to survive termination by their nature shall remain in full force and effect.
  `,
  },
  {
    id: 22,
    text: 'No Warranties',
    desc: `The Owner may, from time to time and at any time without notice to You, modify these Terms of Service. You agree that the Owner has the right to modify these Terms of Service or revise anything contained herein. You further agree that all modifications to these Terms of Service are in full force and effect immediately upon posting on the Website and that modifications or variations will replace any prior version of these Terms of Service unless prior versions are specifically referred to or incorporated into the latest modification or variation of these Terms of Service.
  <br/>
a) To the extent any part or sub-part of these Terms of Service is held ineffective or invalid by any court of law, You agree that the prior, effective version of these Terms of Service shall be considered enforceable and valid to the fullest extent.
  <br/>
b) You agree to routinely monitor these Terms of Service and refer to the Effective Date posted at the top of these Terms of Service to note modifications or variations. You further agree to clear Your cache when doing so to avoid accessing a prior version of these Terms of Service. You agree that Your continued use of the Website after any modifications to these Terms of Service is a manifestation of Your continued assent to these Terms of Service.
  <br/>
c) In the event that You fail to monitor any modifications to or variations of these Terms of Service, You agree that such failure shall be considered an affirmative waiver of Your right to review the modified Agreement.
`,
  },
  {
    id: 23,
    text: 'Limitation On Liability',
    desc: `
   You agree that Your use of the Website and Services is at Your sole and exclusive risk and that any Services provided by Us are on an "As Is" basis. The Owner hereby expressly disclaims any and all express or implied warranties of any kind, including, but not limited to the implied warranty of fitness for a particular purpose and the implied warranty of merchantability. The Owner makes no warranties that the Website or Services will meet Your needs or that the Website or Services will be uninterrupted, error-free, or secure. The Owner also makes no warranties as to the reliability or accuracy of any information on the Website or obtained through the Services. You agree that any damage that may occur to You, through Your computer system, or as a result of the loss of Your data from Your use of the Website or Services is Your sole responsibility and that the Owner is not liable for any such damage or loss.
         <br/>
   All information, software, products, services and related graphics provided on this site are "as is" and "as available" basis with without warranty of any kind, either expressed or implied. The Website disclaims all warranties, expressed or implied including, without limitation, all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement or arising from a course of dealing, usage, or trade practice. The company makes no representation about the suitability of the information, software, products, and services contained on this Website for any purpose, and the inclusion or offering of any products or services on this Website does not constitute any endorsement or recommendation of such products or services.
         <br/>
   The Website makes no warranty that the use of the Website will be uninterrupted, timely, secure, without defect or error-free. You expressly agree that the use of the site is at your own risk. The Website shall not be responsible for any content found on the Website.
         <br/>
   Your use of any information or materials on this site or otherwise obtained through the use of this Website is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through this website meet your specific requirements.
         <br/>
   The Website assumes no responsibility for the accuracy, currency, completeness or usefulness of information, views, opinions, or advice in any material contained on the Website. Any information from third parties or advertisers is made available without making any changes and so the Website cannot guarantee accuracy and is not liable for any inconsistencies arising thereof. All postings, messages, advertisements, photos, sounds, images, text, files, video, or other materials posted on, transmitted through, or linked from the Website, are solely the responsibility of the person from whom such Content originated, and the Website does not control and is not responsible for Content available on the Website.
         <br/>
   There may be instances when incorrect information is published inadvertently on our Website or in the Service such as typographical errors, inaccuracies or omissions that may relate to product descriptions, pricing, promotions, offers, product shipping charges, transit times and availability. Any errors, inaccuracies, or omissions may be corrected at our discretion at any time, and we may change or update information or cancel orders if any information in the Service or on any related website is inaccurate at any time without prior notice (including after you have submitted your order).
         <br/>
   We undertake no obligation to update, amend or clarify information in the Service or on any related website, including without limitation, pricing information, except as required by law. No specified update or refresh date applied in the Service or on any related website should be taken to indicate that all information in the Service or on any related website has been modified or updated.
         <br/>
   The Website shall not be responsible for any interaction between you and the other users of the Website. Under no circumstances will the Website be liable for any goods, services, resources, or content available through such third-party dealings or communications, or for any harm related thereto. The Website is under no obligation to become involved in any disputes between you and other users of the Website or between you and any other third parties. You agree to release the Website from any and all claims, demands, and damages arising out of or in connection with such dispute.
         <br/>
   You agree and understand that while the Website has made reasonable efforts to safeguard the Website, it cannot and does not ensure or make any representations that the Website or any of the information provided by You cannot be hacked by any unauthorized third parties. You specifically agree that the Website shall not be responsible for unauthorized access to or alteration of Your transmissions or data, any material or data sent or received or not sent or received, or any transactions entered into through the Website.
         <br/>
   You hereby agree and confirm that the Website shall not be held liable or responsible in any manner whatsoever for such hacking or any loss or damages suffered by you due to unauthorized access of the Website by third parties or for any such use of the information provided by You or any spam messages or information that You may receive from any such unauthorized third party (including those which are although sent representing the name of the Website but have not been authorized by the Website) which is in violation or contravention of this Terms of Service or the Privacy Policy.
         <br/>
   You specifically agree that the Website is not responsible or liable for any threatening, defamatory, obscene, offensive, or illegal content or conduct of any other party or any infringement of another's rights, including intellectual property rights. You specifically agree that the Website is not responsible for any content sent using and/or included on the Website by any third party.
         <br/>
   The Website has no liability and will make no refund in the event of any delay, cancellation, strike, force majeure, or other causes beyond their direct control, and they have no responsibility for any additional expense omissions delays or acts of any government or authority.
         <br/>
   You will be solely responsible for any damage to your computer system or loss of data that results from the download of any information and/or material. Some jurisdictions do not allow the exclusion of certain warranties, so some of the above exclusions may not apply to you.
         <br/>
   In no event shall the Website be liable for any direct, indirect, punitive, incidental, special, consequential damages or any damages whatsoever including, without limitation, damages for loss of use, data or profits, arising out of or in any way connected with the use or performance of the site, with the delay or inability to use the site or related services, the provision of or failure to provide Services, or to deliver the products or for any information, software, products, services and related graphics obtained through the site, or any interaction between you and other participants of the Website or otherwise arising out of the use of the Website, damages resulting from use of or reliance on the information present, whether based on contract, tort, negligence, strict liability or otherwise, even if the Website or any of its affiliates/suppliers has been advised of the possibility of damages. If despite the limitation above, the Company is found liable for any loss or damage which arises out of or in any way connected with the use of the Website and/ or provision of Services, then the liability of the Company will in no event exceed, 50% (Fifty per cent) of the amount you paid to the Company in connection with such transaction(s) on this Website.
         <br/>
   You accept all responsibility for and hereby agree to indemnify and hold harmless the company from and against, any actions taken by you or by any person authorized to use your account, including without limitation, disclosure of passwords to third parties. By using the Website, you agree to defend, indemnify, and hold harmless the indemnified parties from any and all liability regarding your use of the site or participation in any site's activities. If you are dissatisfied with the Website, or the Services or any portion thereof, or do not agree with these terms, your only recourse and exclusive remedy shall be to stop using the site.
     `,
  },
  {
    id: 24,
    text: 'General Provisions',
    desc: `a) <b style="color:black">LANGUAGE</b>: All communications made or notices given pursuant to these Terms of Service shall be in the English language.
   <br/>
b) <b style="color:black">JURISDICTION</b>, VENUE & GOVERNING LAW: Through Your use of the Website or Services, You agree that the laws of India shall govern any matter or dispute relating to or arising out of these Terms of Service, as well as any dispute of any kind that may arise between You and the Owner, with the exception of its conflict of law provisions. In case any litigation specifically permitted under these Terms of Service is initiated, the Parties agree to submit to the exclusive jurisdiction of the courts at Hyderabad, Telangana, India. The Parties agree that this choice of law, venue, and jurisdiction provision is not permissive, but rather mandatory in nature. You hereby waive the right to any objection of venue, including assertion of the doctrine of forum non-conveniens or similar doctrine.
   <br/>
c) <b style="color:black">SEVERABILITY</b>: If any part or sub-part of these Terms of Service is held invalid or unenforceable by a court of law or competent arbitrator, the remaining parts and sub-parts will be enforced to the maximum extent possible. In such condition, the remainder of these Terms of Service shall continue in full force.
   <br/>
d) <b style="color:black">NO WAIVER</b>: In the event that We fail to enforce any provision of these Terms of Service, this shall not constitute a waiver of any future enforcement of that provision or of any other provision. Waiver of any part or sub-part of these Terms of Service will not constitute a waiver of any other part or sub-part.
   <br/>
e) <b style="color:black">HEADINGS FOR CONVENIENCE ONLY</b>: Headings of parts and sub-parts under these Terms of Service are for convenience and organization, only. Headings shall not affect the meaning of any provisions of these Terms of Service.
   <br/>
f) <b style="color:black">NO AGENCY</b>, PARTNERSHIP OR JOINT VENTURE: No agency, partnership, or joint venture has been created between the Parties as a result of these Terms of Service. No Party has any authority to bind the other to third parties.
   <br/>
g) <b style="color:black">ELECTRONIC COMMUNICATIONS PERMITTED</b>: Electronic communications are permitted to both Parties under these Terms of Service, including e-mail or fax. For any questions or concerns, please email Us at the following address: reviewdale@gmail.com.
 `,
  },
];

export const POLICY = [
  {
    id: 1,
    text: 'General',
    desc: `A. This Website with the URL of <a style="color: #0598FA" href="www.reviewdale.com">www.reviewdale.com</a> ("Website/Site") is operated by <a style="color: #0598FA" href="www.reviewdale.com">Reviewdale</a> ("We/Our/Us"). We are committed to protecting and respecting your privacy. We do collect your personal information and process your personal data in accordance with the IT Act, 2000 (21 of 2000) and other national and state laws which relate to the processing of personal data. Please read the following carefully to understand our views and practices regarding your personal data.
   <br/>
   
B. We collect your personal information in order to provide and continually improve our products and services.
   <br/>
  
C. Our privacy policy is subject to change at any time without notice. To make sure you are aware of any changes, please review this policy periodically.
   <br/>
   
D. All partner firms and any third party working with or for Us, and who have access to personal information, will be expected to read and comply with this policy.
 `,
  },
  {
    id: 2,
    text: 'How We Collect The Information',
    desc: `By using the Website, You warrant that You have read and reviewed these Terms of Service and that You agree to be bound by them. If You disagree to be bound by these Terms of Service, please leave the Website immediately. The Owner only agrees to provide use of this Website and Services to You if You assent to these Terms of Service. Further, based on the Services obtained by a User, additional terms of service in respect of the specific Services may apply, which shall be deemed an agreement between the Users and the Owner.
    `,
  },
  {
    id: 3,
    text: 'Information We Collect',
    desc: `<!DOCTYPE html>

  <p>a) We collect information primarily to provide better services to all of our customers.
    <br/>
b) We collect the following information from you when you use or signup on our Website: Name, email address, Postal address and Phone number
    <br/>
c) We do collect the following sensitive personal information from you when you use or sign up on our Website: *Financial data*
    <br/>
d) When you visit our Site, some information is automatically collected. This may include information such as the Operating Systems (OS) running on your device, Internet Protocol (IP) address, access times, browser type, and language, and the website you visited before our Site. We also collect information about how you use Our products or services.
    <br/>
e) We automatically collect purchase or content use history, which we sometimes aggregate with similar information from other customers to create features such as Best Seller, Top Rated, etc.
    <br/>
f) The full Uniform Resource Locators (URL) clickstream to, through and from our website (including date and time); cookie number; products and/or content you viewed or searched for; page response times; download errors; length of visits to certain pages; page interaction information (such as scrolling, clicks, and mouse-overs).
    <br/>
g) We automatically collect information using "Cookies". Cookies are small data files stored on your hard drive. Among other things, cookies help us improve our Site, our marketing activities, and your experience. We use cookies to see which areas and features are popular and to count visits to our Site.
    <br/>
h) Most Web browsers are set to accept cookies by default. If you prefer, you can choose to set your browser to remove cookies and reject cookies. If you set your browser to reject cookies, some features will be unavailable. For more information on how to reject cookies, see your browser's instructions on changing your cookie settings.
    <br/>
i) By using this Website, you are agreeing that We may advertise your feedback on the Website and marketing materials.
    <br/>
j) We will retain your information as long as we require this to provide you with the goods and services and for such period as mandated by the laws concerned.
    <br/>
k) If you opt to receive marketing correspondence from us, subscribe to our mailing list or newsletters, enter into any of our competitions or provide us with your details at networking events, we may use your personal data for our legitimate interests in order to provide you with details about our goods, services, business updates and events.
  </p>
`,
  },
  {
    id: 4,
    text: 'How We Use Information',
    desc: `
 
          <p>a) We use the information we collect primarily to provide, maintain, protect, and improve our current products and services.
            
              <br/>
  b) We use the information collected through this website asdescribed in this policy and we may use your information to:
              <br/>
             
  I) Improve our services, Site and how we operate our businesses;
              <br/>
             
  II) Understand and enhance your experience using our Site, products, and services;
              <br/>
  III) Personalize our products or services and make recommendations;
              <br/>
  IV) Provide and deliver products and services you request;
              <br/>
  V) Process, manage, complete, and account for transactions;
              <br/>
  VI) Provide customer support and respond to your requests, comments, and inquiries;
              <br/>
              
  VII) Create and manage the online accounts you manage on our Website;
              <br/>
  VIII) Send you related information, including confirmations, invoices, technical notices, updates, security alerts and support and administrative messages;
              <br/>
  IX) Communicate with you about promotions, upcoming events, and news about products and services;
              <br/>
  X) We may process your personal information without your knowledge or consent where required by applicable law or regulation for the purposes of verification of identity or for prevention, detection, or investigation, including of cyber incidents, prosecution, and punishment of offences;
              <br/>
  XI) Protect, investigate, and deter fraudulent, unauthorized, or illegal activity.
              <br/>
          </p>`,
  },

  {
    id: 5,
    text: 'Data Transfer',
    desc: `
		<p>
		    a) Information about our users is an important part of our business and we take due care to protect the same.
		
			<br/>
b) We share your data with your consent or to complete any transaction or provide any product or service you have requested or authorized. We also share data with our affiliates and subsidiaries, with vendors working on our behalf.
			
			<br/>
c) We may employ other companies and individuals to perform functions on our behalf. The functions include providing data and analytical services, delivering e-mail, removing repetitive information from customer lists, providing marketing assistance, providing search results and links (including paid listings and links), processing payments, transmitting content, scoring credit risk, and providing customer service.
		
			<br/>
d) These third-party service providers have access to personal information needed to perform their functions but may not use it for other purposes. Further, they must process the personal information in accordance with this Privacy Policy and as permitted by applicable data protection laws.
		
			<br/>
e) We release accounts and other personal information when we believe it is appropriate to comply with the law, enforce or apply our conditions of use, and other agreements, and protect the rights, property or safety of Us, our users, or others. This includes exchanging information with other companies and organizations for fraud protection and credit risk reduction.
		</p>
	`,
  },
  {
    id: 6,
    text: 'Cookies',
    desc: `
   <p>a) To optimize our web presence, we use cookies. These are small text files stored on your computer's main memory. These cookies are deleted after you close the browser. Other cookies remain on your computer (long-term cookies) and permit their recognition on your next visit. This allows us to improve your access to our site. This helps us to learn more about your interests and provides you with essential features and services, including:
     <br/>
     <br/>
I) <span style="color:#0598FA">Managing your session and login security.</span>
     <br/>
II) Conducting research and diagnostics to improve the content, products, and services.
     <br/>
III) Preventing fraudulent activity.
     <br/>
b) Our cookies allow you to take advantage of some of our essential features. For instance, if you block or otherwise reject our cookies, you will not be able to use any products or services that require you to sign in.
     <br/>
c) Approved third parties also may set cookies when you interact with Our services.
     <br/>
d) Third parties include search engines, providers of measurement and analytics services, social media networks, and advertising companies.
     <br/>
e) Third parties use cookies in the process of delivering content, including ads relevant to your interests, to measure the effectiveness of their ads, and to perform services on our behalf of Us.
     <br/>
f) You can prevent the storage of cookies by choosing a "disable cookies" option in your browser settings. But this can limit the functionality of our services.
   </p>
 `,
  },
  {
    id: 7,
    text: 'Data Security',
    desc: `
    
a) We take due care to protect customer data. Technical measures are in place to prevent unauthorized or unlawful access to data and against accidental loss or destruction of, or damage to, data. The employees who are dealing with the data have been trained to protect the data from any illegal or unauthorized usage.
    <br/>
b) We work to protect the security of your information during transmission by using Secure Sockets Locker (SSL) software, which encrypts information you input. SSL allows sensitive information such as credit card numbers, UID and login credentials to be transmitted securely.
    <br/>
c) We maintain physical, electronic, and procedural safeguards in connection with the collection, storage, and disclosure of personal customer information.
    <br/>
d) We take reasonable steps to help protect your personal information in an effort to prevent loss, misuse, unauthorized access, disclosure alteration and destruction. It is your responsibility to protect your user names and passwords to help prevent anyone from accessing or abusing your accounts and services. You should not use or reuse the same passwords you use with other accounts as your password for our services.
    <br/>
e) It is important for you to protect against unauthorized access to your password and your computers, devices, and applications. Be sure to sign off when you finish using a shared computer.
    <br/>
    
f) The information you provide to us is shared on our secure servers. We have implemented appropriate physical, technical and organizational measures designed to secure your information against accidental loss and unauthorized access, use, alteration, or disclosure. In addition, we limit access to personal data to those employees, agents, contractors, and other third parties that have a legitimate business need for such access.
    <br/>
g) Information collected from you will be stored for such period as required to complete the transaction entered into with you or such period as mandated under the applicable laws.
  </p>
`,
  },
  {
    id: 8,
    text: 'Links To Thirt-Party Sites/Apps',
    desc: `
   Our Site may, from time to time, contain links to and from other websites of third parties. Please note that if you follow a link to any of these websites, such websites will apply different terms to the collection and privacy of your personal data, and we do not accept any responsibility or liability for these policies. When you leave our Site, we encourage you to read the privacy policy of every website you visit.`,
  },
  {
    id: 9,
    text: 'Social Network Plugins',
    desc: `
  This Website incorporates plugins and/or buttons for social networks, in order to allow easy sharing on your favourite social networks. These plugins are programmed so as not to set any cookies when assessing the page to safeguard the privacy of users. Cookies may be set if you make voluntary use of the plugin. The collection and use of information obtained by means of the plugin are governed by the respective privacy policies of the social networks.`,
  },
  {
    id: 10,
    text: 'Sharing Personal Information',
    desc: `<!DOCTYPE html>
    <html>
      <head>
        <title>Codebeautify.org Text to HTML Converter</title>
      </head>
      <body>
        <p>a) We do not share your personal data with third parties without your prior consent other than:
          <br/>
    I) With third parties who work on our behalf provided such third parties adhere to the data protection principles set out in the IT Act, 2000 (21 of 2000) and other applicable legislation, or enter into a written agreement with Us requiring that the third party provide at least the same level of privacy protection as is required by such principles;
          <br/>
    II) To comply with laws or to respond to lawful requests and legal processes;
          <br/>
    III) To protect the rights and property of Us, our agents, customers, and others including enforcing our agreements, policies, and terms of service;
          <br/>
    IV) In an emergency, including to protect the personal safety of any person; and
          <br/>
    V) For the purpose of a business deal (or negotiation of a business deal) involving the sale or transfer of all or a part of our business or assets (business deals may include, for example, any merger, financing, acquisition, divestiture, or bankruptcy transaction or proceeding).
        </p>
      </body>
    </html>`,
  },
  {
    id: 11,
    text: 'Children',
    desc: 'If you are under 18, or the age of majority in the jurisdiction in which you reside, you may only use Our Website with the consent of your parent or legal guardian. In any case, We will not be liable for any cause of action that arose due to non-compliance with this section.',
  },
  {
    id: 12,
    text: 'Change To This Policy',
    desc: `<!DOCTYPE html>
   <html>
     <head>
       <title>Codebeautify.org Text to HTML Converter</title>
     </head>
     <body>
       <p>We may change this policy from time to time. If we make any changes to this policy, we will change the "Last Updated" date above. You agree that your continued use of our services after such changes have been published to our services will constitute your acceptance of the such revised policy.
         <br/>
         <br/>
   If you have any concerns about privacy or grievances with Us, please contact us with a thorough description and we will try to resolve the issue for you.
       </p>
     </body>
   </html>`,
  },
  {
    id: 14,
    text: 'Contact Details',
    desc: `<!DOCTYPE html>
        <p>Name - Faiz Jawed
          <br/>
    Phone - +91-9818895965
          <br/>
    Email - <a style="color:#0598FA" href="mailto:faizjawed.works@gmail.com">faizjawed.works@gmail.com</a>
          <br/>
    Address - C-1301, Ramky Towers, near AIG, Gachibowli, Hyderabad, Telangana, India - 500032
        </p>
      `,
  },
];
